export default function Hero() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, targetId: string) => {
    e.preventDefault();
    const target = document.querySelector(targetId);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-background-50 via-background-50/95 to-background-100/80 z-10"></div>
        <div className="absolute top-0 right-0 w-full md:w-[55%] h-full opacity-40 md:opacity-50">
          <img
            src="https://readdy.ai/api/search-image?query=Cinematic%20abstract%20composition%20with%20warm%20golden%20amber%20light%20rays%20streaming%20across%20deep%20dark%20indigo%20black%20background%2C%20artistic%20film%20projector%20light%20beams%20and%20soft%20lens%20flares%2C%20elegant%20movie%20theater%20velvet%20curtain%20textures%20subtle%20in%20shadows%2C%20dramatic%20contrast%20with%20rich%20warm%20highlights%20and%20deep%20noir%20shadows%2C%20high%20end%20cinema%20branding%20aesthetic%20minimal%20yet%20powerful%2C%20professional%20editorial%20film%20photography%20style%20with%20cinematic%20color%20grading&width=900&height=1000&seq=hero-main-visual&orientation=portrait"
            alt="成全影院 - 最新电影新剧上线抢先看热门综艺"
            className="w-full h-full object-cover object-top"
          />
        </div>
      </div>

      <div className="relative z-20 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-[1400px] mx-auto">
          <div className="flex flex-col lg:flex-row items-start gap-10 lg:gap-16">
            <div className="flex-1 w-full max-w-[640px]">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-500/15 border border-primary-500/25 mb-6">
                <span className="w-2 h-2 rounded-full bg-primary-400 animate-pulse"></span>
                <span className="text-xs font-medium text-primary-300 whitespace-nowrap">每日更新 · 稳定高速</span>
              </div>

              <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-50 leading-tight tracking-tight">
                成全影院 · 最新电影新剧上线抢先看
              </h1>

              <p className="mt-4 text-lg md:text-xl font-heading font-medium text-primary-400">
                热门综艺更新快，电视剧全集免费在线高清不卡顿
              </p>

              <p className="mt-6 text-sm md:text-base text-foreground-400 leading-relaxed max-w-[560px]">
                成全影院汇聚海量最新电影、热播新剧和热门综艺资源，覆盖动作、悬疑、爱情、喜剧、科幻等全类型题材。每日同步更新院线大片与平台独播剧集，高清画质流畅播放，无需等待缓冲。无论追剧党还是电影迷，这里都是你的云端私人影院，随时随地畅享极致观影体验。
              </p>

              <div className="flex flex-wrap items-center gap-6 md:gap-10 mt-8">
                <div className="flex items-center gap-2">
                  <div className="w-10 h-10 rounded-lg bg-primary-500/10 flex items-center justify-center">
                    <i className="ri-movie-2-line text-lg text-primary-400"></i>
                  </div>
                  <div>
                    <div className="text-lg font-bold text-foreground-100">20000+</div>
                    <div className="text-xs text-foreground-500">影视资源</div>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-10 h-10 rounded-lg bg-accent-500/10 flex items-center justify-center">
                    <i className="ri-flashlight-line text-lg text-accent-400"></i>
                  </div>
                  <div>
                    <div className="text-lg font-bold text-foreground-100">每日更新</div>
                    <div className="text-xs text-foreground-500">同步热播</div>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-10 h-10 rounded-lg bg-secondary-500/10 flex items-center justify-center">
                    <i className="ri-shield-check-line text-lg text-secondary-400"></i>
                  </div>
                  <div>
                    <div className="text-lg font-bold text-foreground-100">高清流畅</div>
                    <div className="text-xs text-foreground-500">安全无广告</div>
                  </div>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row items-center gap-4 mt-10">
                <a
                  href="#index"
                  onClick={(e) => handleScroll(e, '#index')}
                  className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-lg bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm transition-all duration-200 no-underline whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-play-circle-line text-lg"></i>
                  开始观影
                </a>
                <a
                  href="#ranking"
                  onClick={(e) => handleScroll(e, '#ranking')}
                  className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-lg bg-background-200/80 hover:bg-background-300 text-foreground-200 font-medium text-sm border border-background-300/50 transition-all duration-200 no-underline whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-fire-line text-lg"></i>
                  热度榜单
                </a>
              </div>
            </div>

            <div className="hidden lg:flex flex-1 items-center justify-center">
              <div className="relative w-full max-w-[480px] aspect-[4/5] rounded-2xl overflow-hidden border border-background-200/30">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20cinematic%20movie%20poster%20collage%20design%20with%20warm%20golden%20amber%20and%20deep%20navy%20tones%2C%20abstract%20film%20strip%20elements%20and%20soft%20bokeh%20lights%2C%20dramatic%20spotlight%20effect%20on%20dark%20velvet%20curtain%20texture%2C%20luxurious%20cinema%20atmosphere%20with%20subtle%20geometric%20patterns%2C%20high%20end%20entertainment%20branding%20aesthetic%2C%20rich%20contrast%20editorial%20photography%20style%2C%20premium%20visual%20identity%20for%20movie%20streaming%20platform&width=600&height=750&seq=hero-poster-visual&orientation=portrait"
                  alt="成全影院 - 海量影视资源"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/60 via-transparent to-transparent"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}